export default __webpack_public_path__ + "static/media/badge-captain-line.e6e165a7.svg";